// extracted by mini-css-extract-plugin
export default {"titleWrapper":"SummaryToggle_titleWrapper__yVhZ6","title":"SummaryToggle_title__WymSk","wrapper":"SummaryToggle_wrapper__Zvc6C","popup":"SummaryToggle_popup__GTjpj"};